import { useEffect, useRef } from 'react';
import { isShallowEqual } from "@ajayvikas/common-utils";
function shallowCompare(prevValue, currValue) {
    if (!prevValue || !currValue) {
        return false;
    }
    if (prevValue === currValue) {
        return true;
    }
    if (prevValue.length !== currValue.length) {
        return false;
    }
    for (let i = 0; i < prevValue.length; i += 1) {
        if (!isShallowEqual(prevValue[i], currValue[i])) {
            return false;
        }
    }
    return true;
}
const EMPTY_ARRAY = [];
function useShallowCompare(dependencies) {
    const ref = useRef(EMPTY_ARRAY);
    const updateRef = useRef(0);
    if (!shallowCompare(ref.current, dependencies)) {
        ref.current = dependencies;
        updateRef.current += 1;
    }
    return [updateRef.current];
}
export function useShallowEffect(cb, dependencies) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(cb, useShallowCompare(dependencies || EMPTY_ARRAY));
}
